import styled from '@emotion/styled';

export const Container = styled.button`
  display: block;
  padding: 0.8em 1.2em;
  flex: 3.6em;
  color: #ffffff;
  font-size: 1.25em;
  line-height: 120%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.8em;
  transition: background-color 150ms ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const Check = styled.div`
  width: 2em;
  height: 2em;
`;
